import { render, staticRenderFns } from "./ControlService.vue?vue&type=template&id=4565d808&scoped=true"
import script from "./ControlService.vue?vue&type=script&lang=js"
export * from "./ControlService.vue?vue&type=script&lang=js"
import style0 from "./ControlService.vue?vue&type=style&index=0&id=4565d808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4565d808",
  null
  
)

export default component.exports